import { G_VideoRatingCategory } from "~/lib/graphql";

/**
 * 詳細でレーティング区分に基づくflagを返す関数
 */
export const getVideoRatingForDetail = (ratingCategory: G_VideoRatingCategory) => {
  const flags = {
    isGravure: false,
    isRegularRestricted: false,
    isOther: false,
  };
  switch (ratingCategory) {
    case G_VideoRatingCategory.R18Gravure:
      return { ...flags, isGravure: true };
    case G_VideoRatingCategory.R18:
    case G_VideoRatingCategory.R15:
      return { ...flags, isRegularRestricted: true };
    default:
      return { ...flags, isOther: true };
  }
};
